import Grid from '@material-ui/core/Grid';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import React from 'react';

const style = {
  grid: {
    margin: '0 -15px !important',
    width: 'unset',
    gridAutoRows: '1fr',
  }
};

function GridContainer(props) {
  const { classes, children, ...rest } = props;
  return (
    <Grid container {...rest} className={classes.grid}>
      {children}
    </Grid>
  );
}

export default withStyles(style)(GridContainer);
